import { get } from './request'

export async function fetchWebinars({ language = 'hu' }) {
  console.log('getting webinars', language)
  const response = await get<any>(`/webinars?lng=${language}`)
  return response
}
